
const LOGO_STARS = [
  "                                    *    ***",
  "                           **      ***  ****",
  "                       *******    **** ****",
  "                    *********    **** ****",
  "                 *******        ************",
  "                ******   ********************",
  "                 ********************** ****",
  "              ************    ***  ***   *******   *******   **      **  **     **  *******   ****** *********",
  "          *********  ****    ***  ***   ********  *********  ****    ** ****    ** *******  ********* ********",
  "      ********    ******    ***  ***   **        ***     *** *****   ** *****   ** ***      **           **",
  "   *******    ********     ****  ***   **        **       ** **  *** ** *** *** ** ******* ***           **",
  " ******* **********        ***  ***    ***       ***     *** **   ***** ***  ***** ***      **           **",
  "**************             **  ****     ********  *********  **    **** ***    *** ********  ********    **",
  "*********                      ***        *****     *****     *      *   *      *   ******     *****     **",
].join("\n");

const LOGO_STYLE = [
  // "color: #c60970",
  "font-family: monospace",
  "font-size: 11px",
  "font-weight: bold",
  "line-height: 1",
].join("; ");

export const printConsoleBanner = () => {
  try {
    console.log(`%c${LOGO_STARS}`, LOGO_STYLE);
    console.log(
      "%cSH Connect%c — compliance management",
      "color: #c60970; font-size: 13px; font-weight: bold",
      "color: #818188; font-size: 13px"
    );
  } catch (error) {
    // A decorative banner must never break app boot.
  }
};
